import React from 'react';
import "../../styles/prog-offered-courses/main.css";
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id='programOfferCourses'>
            <div className="program-offer mb-5 position-relative">
                <div className="container program-main">
                    <h1 className="my-heading text-center">Programs offered</h1>
                    <div className="box">
                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover active"
                                    id="pills-history1-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-history1"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-history1"
                                    aria-selected="true"
                                >
                                    Under Graduate
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover"
                                    id="pills-vision-mision2-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-vision-mision2"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-vision-mision2"
                                    aria-selected="false"
                                >
                                    Post Graduate
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover"
                                    id="pills-founder3-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-founder3"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-founder3"
                                    aria-selected="false"
                                >
                                    PHD
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover"
                                    id="pills-chancellor4-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-chancellor4"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-chancellor4"
                                    aria-selected="false"
                                >
                                    PG Diploma
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover"
                                    id="pills-vice-chancellorunder5-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-vice-chancellorunder5"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-vice-chancellorunder5"
                                    aria-selected="false"
                                >
                                    diploma
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="normal-button border-pills-hover"
                                    id="pills-governance6-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-governance6"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-governance6"
                                    aria-selected="false"
                                >
                                    Certificate Courses
                                </button>
                            </li>
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div
                                className="tab-pane fade show active"
                                id="pills-history1"
                                role="tabpanel"
                                aria-labelledby="pills-history1-tab"
                            >
                                <div className="big-section" id="founder">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>under graduate</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>B.A. (Journalism)(B.J.M.C)</p>
                                                <p>B.sc. (NEP)</p>
                                                <p>B.B.A</p>
                                                <p>B.B.A (Hospital Administration)</p>
                                                <p>B.Tech (Information Technology)</p>
                                                <p>B.Tech (Chemical Engineering)</p>
                                                <p>B.Tech (Electronics and Communication Engineering)</p>
                                                <p>B.Tech (Mechanical Engineering)</p>
                                                <p>B.com (Honours)</p>
                                                <p>B.A. LLB</p>
                                                <p>B.Sc.(Food Microbiology safety Quality Control)</p>
                                                <p>B.P.Ed.</p>
                                                <p>B.Sc.(Computer Science Honours)</p>
                                                <p>B.Sc.(NEP)</p>
                                                <p>B.Sc.(NEP)</p>
                                                <p>B.Sc.(NEP)</p>
                                                <p>B.Tech (Agriculture Engineering)</p>
                                                <p>B.Sc.(NEP)</p>
                                                <p>B.Sc.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                                <p>B.A.(NEP)</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Botany</p>
                                                <p>Journalism And Mass Communication</p>
                                                <p>Institute of Business Studies</p>
                                                <p>Institute of Business Studies</p>
                                                <p>Institute of Engineering And Technology</p>
                                                <p>Institute of Engineering And Technology</p>
                                                <p>Institute of Engineering And Technology</p>
                                                <p>Institute of Engineering And Technology</p>
                                                <p>Commerce</p>
                                                <p>Institute of Legal Studies</p>
                                                <p>Microbiology</p>
                                                <p>Physical Education</p>
                                                <p>Department of Computer Application</p>
                                                <p>Chemistry</p>
                                                <p>Statistics</p>
                                                <p>Physics</p>
                                                <p>Institute of Engineering And Technology</p>
                                                <p>Zoology</p>
                                                <p>Mathematics</p>
                                                <p>Sanskrit</p>
                                                <p>Political Science</p>
                                                <p>Psychology</p>
                                                <p>Sociology</p>
                                                <p>History</p>
                                                <p>English</p>
                                                <p>Economics</p>
                                                <p>Hindi</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-vision-mision2"
                                role="tabpanel"
                                aria-labelledby="pills-vision-mision2-tab"
                            >
                                <div className="big-section" id="our-vision">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>Post graduate</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>M.Sc. (Agriculture)</p>
                                                <p>M.Ed.</p>
                                                <p>M.P.Ed.</p>
                                                <p>MBA</p>
                                                <p>MBA(Hospital Administration)</p>
                                                <p>L.L.M</p>
                                                <p>M.Sc.(Agriculture)</p>
                                                <p>M.A.</p>
                                                <p>M.A. (Yoga Science)</p>
                                                <p>M.Sc.(Bioinformatics)</p>
                                                <p>M.Sc.(Medical Microbiology)</p>
                                                <p>M.Sc.(Applied Microbiology)</p>
                                                <p>M.Sc.(Agriculture)(Entom ology)</p>
                                                <p>M.Sc.(Agriculture)(Plant Pathology)</p>
                                                <p>M.Sc.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>M.A.</p>
                                                <p>MSW</p>
                                                <p>MLibISc</p>
                                                <p>MPA</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.</p>
                                                <p>M.Sc.(Biochemistry)</p>
                                                <p>M.Sc.(Food Nutrition)</p>
                                                <p>M.Sc.(Environment Science)</p>
                                                <p>M.Sc.(Polymer Science Chemical Technology)</p>
                                                <p>M.A.</p>
                                                <p>M.Com.</p>
                                                <p>M.Sc.(Agriculture)</p>
                                                <p>M.Sc.(Agriculture)</p>
                                                <p>M.A.(J M C)</p>
                                                <p>MCA</p>
                                                <p>MFA(Applied Arts)</p>
                                                <p>MFA(Drawing and Painting)</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Food Science And Technology</p>
                                                <p>Education</p>
                                                <p>Physical Education</p>
                                                <p>Institute of Business Studies</p>
                                                <p>Institute of Business Studies</p>
                                                <p> Institute of Legal Studies</p>
                                                <p>Horticulture</p>
                                                <p>Geography</p>
                                                <p>Sanskrit</p>
                                                <p>Microbiology</p>
                                                <p>Microbiology</p>
                                                <p>Microbiology</p>
                                                <p>Plant Protection</p>
                                                <p>Plant Protection</p>
                                                <p>Toxicology</p>
                                                <p>Sanskrit</p>
                                                <p>Urdu</p>
                                                <p>English</p>
                                                <p>History</p>
                                                <p>Political Science</p>
                                                <p>Sociology</p>
                                                <p>Economics</p>
                                                <p>Psychology</p>
                                                <p>Social Work</p>
                                                <p>Library Information Science</p>
                                                <p>Political Science</p>
                                                <p>Physics</p>
                                                <p>Chemistry</p>
                                                <p>Mathematics</p>
                                                <p>Botany</p>
                                                <p>Zoology</p>
                                                <p>Statistics</p>
                                                <p>Microbiology</p>
                                                <p>Biotechnology</p>
                                                <p>Chemistry</p>
                                                <p>Home Science</p>
                                                <p>Zoology</p>
                                                <p>Chemistry</p>
                                                <p>Hindi</p>
                                                <p>Commerce</p>
                                                <p>Genetics Plant Breeding</p>
                                                <p>Seed Science And Technology</p>
                                                <p>Journalism And Mass Communication</p>
                                                <p>Department Of Computer Application</p>
                                                <p>Fine Arts</p>
                                                <p>Fine Arts</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-founder3"
                                role="tabpanel"
                                aria-labelledby="pills-founder3-tab"
                            >
                                <div className="big-section">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>Ph.D</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>Ph.D.</p>
                                                <p>D.Sc.</p>
                                                <p>DLitt</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Physics</p>
                                                <p>Zoology</p>
                                                <p>Microbiology</p>
                                                <p>Toxicology</p>
                                                <p>Journalism And Mass Communication</p>
                                                <p>Education</p>
                                                <p>Physical Education</p>
                                                <p>Institute of Business Studies</p>
                                                <p>Institute of Legal Studies</p>
                                                <p>English</p>
                                                <p>Horticulture</p>
                                                <p>Genetics Plant Breeding</p>
                                                <p>Botany</p>
                                                <p>Chemistry</p>
                                                <p>Mathematics</p>
                                                <p>Statistics</p>
                                                <p>Sociology</p>
                                                <p>Psycology</p>
                                                <p>Political Science</p>
                                                <p>History</p>
                                                <p>Economics</p>
                                                <p>Urdu</p>
                                                <p>Hindi</p>
                                                <p>Physics</p>
                                                <p>Political Science</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-chancellor4"
                                role="tabpanel"
                                aria-labelledby="pills-chancellor4-tab"
                            >
                                <div className="big-section">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>PG Diploma</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>PG Diploma (Film Production)</p>
                                                <p>PG Diploma (GIS Remote Sensing)</p>
                                                <p>PG Diploma (Yoga Science)</p>
                                                <p>PG Diploma (Jyotir Vigyan)</p>
                                                <p>PG Diploma (Karam Kand)</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Journalism And Mass Communication</p>
                                                <p>Geography</p>
                                                <p>Sanskrit</p>
                                                <p>Sanskrit</p>
                                                <p>Sanskrit</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-vice-chancellorunder5"
                                role="tabpanel"
                                aria-labelledby="pills-vice-chancellorunder5-tab"
                            >
                                <div className="big-section">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>Diploma</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>Urdu</p>
                                                <p>French</p>
                                                <p>Russian</p>
                                                <p>Vedic Mathematics</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Urdu</p>
                                                <p>Foreign Language</p>
                                                <p>Foreign Language</p>
                                                <p>Mathematics</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-governance6"
                                role="tabpanel"
                                aria-labelledby="pills-governance6-tab"
                            >
                                <div className="big-section">
                                    <div className="col-lg-3 image">
                                        <img src="assets/images/big-section-1.png" alt="" />
                                    </div>
                                    <div className="col-lg-9 d-flex for-doing">
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>Certficate Courses</h1>
                                                <Link
                                                    to={"/prog-offered"}
                                                    className="normal-button bg-light"
                                                >
                                                    view all
                                                </Link>
                                            </div>
                                            <div className="links">
                                                <p>Proficiency in French</p>
                                                <p>Proficiency in Russian</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 content">
                                            <div className="top">
                                                <h1>DEPARTMENT</h1>
                                            </div>
                                            <div className="links text-col-change">
                                                <p>Foreign Language</p>
                                                <p>Foreign Language</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Link
                            to={"/prog-offered"}
                            className="new-button"
                            style={{
                                position: "absolute",
                                bottom: "-22px",
                                left: "50%",
                                transform: "translateX(-50%)"
                            }}
                        >
                            Apply Now
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Main;